<template lang="pug">
.resultados-exames-container
  ul.corpo-lista
    li.lista(
      v-for="item in resultados",
      :class="[item.confirmado_grafico == 'S' || item.confirmado_laudo == 'S' ? '' : 'inativo']"
    )
      .icn
        img(
          v-if="item.confirmado_grafico == 'S' || item.confirmado_laudo == 'S'",
          src="../../assets/pdf_ativo.svg"
        )
        img(v-else, src="../../assets/pdf_inativo.svg")
      .info
        el-tooltip(:content="item.procedimento", placement="top")
          .nome-procedimento {{ item.procedimento }}
        .dados-procedimento # {{ item.id_agendamento }}, {{ item.data_agendamento }}, {{ item.paciente }}, {{ item.genero }}, {{ item.idade }}, {{ item.convenio }}
        .selo(
          v-if="item.confirmado_grafico == 'S' || item.confirmado_laudo == 'S'"
        )
          img(src="../../assets/garantia.svg")
          | protegido com assinatura digital
        .selo(v-else)
          img(src="../../assets/laudo_indisponivel.svg")
          | O resultado do laudo será disponibilizado em até 5 dias úteis após a realização do procedimento
        .acao-mobile
          .grafico(
            v-if="item.confirmado_grafico == 'S'",
            @click="dowloadArquivo(item.id_agendamento, 'grafico')"
          ) Baixar Gráfico
          .laudo(
            v-if="item.confirmado_laudo == 'S'",
            @click="dowloadArquivo(item.id_agendamento, 'laudo')"
          ) Baixar Laudo
      .acao
        el-button(
          v-if="item.confirmado_grafico == 'S'",
          type="primary",
          @click="dowloadArquivo(item.id_agendamento, 'grafico')"
        ) Baixar Gráfico
        el-button(v-else, type="info") Gráfico Pendente
        el-button(
          v-if="item.confirmado_laudo == 'S'",
          type="primary",
          @click="dowloadArquivo(item.id_agendamento, 'laudo')"
        ) Baixar Laudo
        el-button(v-else, type="info") Laudo Pendente
</template>

<script>
import Services from "../../utils/services";
import moment from "moment";
moment.locale("pt-BR");

export default {
  data: () => ({
    resultados: [],
  }),
  created() {
    this.getResultadosExames();
  },
  methods: {
    async getResultadosExames() {
      let id = localStorage.getItem("_uid");
      let resp = await Services.get(`/paciente/${id}/procedimentos/todos`);
      this.resultados = resp.map((e) => {
        e.data_agendamento = moment(e.data_agendamento).format("L");
        e.idade = moment(e.data_nascimento, "YYYYMMDD").fromNow();
        e.idade = e.idade.split(" ")[1];
        return e;
      });
      console.log("resultados de exames", this.resultados);
    },

    /* Metodo que faz o dowload do aquivo */
    dowloadArquivo(id, tipo) {
      window.open(
        `http://www.neuroms.com.br/api/public/index.php/agendamento/${id}/arquivo/download/${tipo}`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss">
.resultados-exames-container {
  width: 1100px;
  height: calc(100% - 120px);
  margin: 0 auto;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  ul.corpo-lista {
    margin: 0;
    padding: 25px 0;
    box-sizing: border-box;

    li.lista {
      width: 100%;
      height: 115px;
      padding: 0 25px;
      margin-bottom: 15px;
      border: 1px solid #cbcbcb;
      border-radius: 10px;
      box-sizing: border-box;
      cursor: pointer;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.inativo {
        background: #f8f8f8;

        .info {
          .nome-procedimento,
          .dados-procedimento {
            color: #666;
          }
          .nome-procedimento {
            max-width: 560px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .selo {
          color: #ff0808;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      .icn {
        margin-right: 25px;
      }

      .info {
        flex: 1;
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;

        .nome-procedimento {
          font-size: 20px;
          color: #0180ff;
          font-weight: 400;
          margin-bottom: 2px;
        }
        .dados-procedimento {
          display: flex;
          font-size: 16px;
          color: #000;
          font-weight: 100;
        }

        .acao-mobile {
          display: none;
          font-size: 14px;
          margin-left: 10px;
        }
      }

      .selo {
        display: flex;
        align-items: center;
        margin-top: 3px;
        font-size: 15px;
        font-weight: 100;

        img {
          margin-right: 5px;
        }
      }

      .acao {
        .el-button {
          width: 175px;
          height: 50px;
          border-radius: 10px;
          font-size: 17px;

          &.el-button--info {
            background: #dcdcdc;
            color: #666666;
            border-color: #dcdcdc;
          }
          &.el-button--primary {
            background: #0180ff;
            border-color: #0180ff;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .resultados-exames-container {
    width: 360px;

    ul.corpo-lista {
      li.lista,
      li.lista.inativo {
        padding: 0 10px;

        .icn {
          margin-right: 10px;

          img {
            width: 35px;
          }
        }
        .info {
          .nome-procedimento {
            font-size: 14px;
            font-weight: bold;
            max-width: 295px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .dados-procedimento {
            font-size: 12px;
          }
          .selo {
            font-size: 12px;

            img {
              width: 18px;
            }
          }

          .acao-mobile {
            display: flex;
            margin-top: 8px;
            color: #0180ff;

            .grafico {
              margin-right: 10px;
              cursor: pointer;
            }
            .laudo {
              cursor: pointer;
            }
            .laudo,
            .grafico {
              width: 115px;
              height: 20px;
              border: 1px solid #0180ff;
              border-radius: 15px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }

        .acao {
          button {
            display: none;
          }
        }
      }
    }
  }
}
</style>